<template>
  <div class="editor-container">
    <JsonEditorVue
      class="editor-input"
      v-model="eventProxy"
      mode="text"
      v-bind:onRenderMenu="onRenderMenu"
    />
  </div>
</template>


<script>
// https://github.com/cloydlau/json-editor-vue
// https://github.com/josdejong/svelte-jsoneditor
import JsonEditorVue from "json-editor-vue";

export default {
  name: "EventEditor",
  components: {
    JsonEditorVue,
  },
  props: {
    event: {
      type: String,
      default: "",
      require: true,
    },
  },
  computed: {
    eventProxy: {
      get() {
        return this.event;
      },
      set(val) {
        this.$emit("update:event", val);
      },
    },
  },
  methods: {
    onRenderMenu: function (mode, items) {
      const editorMenuItems = items.slice(3, items.length);
      editorMenuItems.splice(4, 1);
      return editorMenuItems;
    },
  },
};
</script>

<style scoped>
.editor-container {
  flex-grow: 1;
  overflow: scroll;
}

.editor-input {
  resize: none;
  white-space: nowrap;
  height: 100%;
  width: 100%;
}
</style>
